import { configureApi } from '@linka/http';
import { getAcceptLanguage } from '@/lib/utils';

configureApi({
  baseUrl: import.meta.env.VITE_API_URL as string,
  defaultHeaders: { 'x-origin-key': 'admin' },
  onRequest: (config) => {
    config.headers.set('Accept-Language', getAcceptLanguage());

    return config;
  },
});
